import { render, staticRenderFns } from "./PaymentDetailsPopup.vue?vue&type=template&id=24c19df0&"
import script from "./PaymentDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailsPopup.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetailsPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports